/** @jsxRuntime classic */
/*@jsx jsx*/

import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import { Button, Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { RichText } from 'components/RichText/RichText';
import { SingleArticleQuery_articleCollection_items_body_links_entries_block_InArticleCtaContainer_fallbackCta } from 'graphql/__generated__/operations/SingleArticleQuery';
import { TrackedComponent, useAvroTracking } from 'tracking';
import { Headline } from './CTACommonStyles';

type props = {
  inArticleCTA: SingleArticleQuery_articleCollection_items_body_links_entries_block_InArticleCtaContainer_fallbackCta;
};

export const FullWidthTextCTA = ({ inArticleCTA }: props) => {
  const { headline, buttonText, buttonUrl, textBody } = inArticleCTA;
  const { emitCTAClickEvent } = useAvroTracking();

  return (
    <CTAWrapper>
      <ActionSection>
        <Headline>{headline}</Headline>
        {textBody ? <RichText body={textBody as any} persona={null} /> : null}
        {buttonText && buttonUrl && (
          <ButtonWrapper>
            <Button
              target="_blank"
              href={buttonUrl!}
              color="primary-alt"
              onClick={() => {
                emitCTAClickEvent({
                  destination_url_address: buttonUrl,
                  interaction_raw_text: buttonText,
                  custom_tracking_fields: {
                    component: TrackedComponent.FullWidthTextCTA,
                    heading: headline,
                  },
                });
              }}
            >
              {buttonText}
            </Button>
          </ButtonWrapper>
        )}
      </ActionSection>
    </CTAWrapper>
  );
};

const CTAWrapper = styled.article`
  border-radius: 5px;
  background-color: ${Colors.peach};
  position: relative;
  overflow: hidden;
`;

const ActionSection = styled.section`
  padding: 30px 20px;
  text-align: center;
  ${mediaQueries.tablet} {
    text-align: left;
    padding: 30px;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;
  text-align: center;
`;
